'use strict';

const Enum = require('./enum');

/**
 * Defines states around credential schedule sync commands.
 *
 * @enum
 * @readonly
 */
const CredentialScheduleSynCommandStates = Object.create(Enum, {
  INTENT: { value: 'intent', enumerable: true },
  COMMIT: { value: 'commit', enumerable: true },
});

/**
 * Defines actions around credential schedule sync commands.
 *
 * @enum
 * @readonly
 */
const CredentialScheduleSynCommandActions = Object.create(Enum, {
  LOAD: { value: 'load', enumerable: true },
  DELETE: { value: 'delete', enumerable: true },
  DISABLE: { value: 'disable', enumerable: true },
  ENABLE: { value: 'enable', enumerable: true },
  UPDATE: { value: 'update', enumerable: true },
});

/**
 * Defines status of credential schedule.
 *
 * @enum
 * @readonly
 */
const CredentialScheduleStates = Object.create(Enum, {
  CREATED: { value: 'created', enumerable: true },
  LOADED: { value: 'loaded', enumerable: true },
  DISABLED: { value: 'disabled', enumerable: true },
  DISABLING: { value: 'disabling', enumerable: true },
  ENABLING: { value: 'enabling', enumerable: true },
  DELETING: { value: 'deleting', enumerable: true },
  UPDATING: { value: 'updating', enumerable: true },
});

/**
 * Defines credential access types
 *
 * @enum
 * @readonly
 */
const CredentialAccessTypes = Object.create(Enum, {
  ALWAYS: { value: 'always', enumerable: true },
  RECURRING: { value: 'recurring', enumerable: true },
  TEMPORARY: { value: 'temporary', enumerable: true },
});

/**
 * Defines keys for credential access times date ranges.
 *
 * @enum
 * @readonly
 */
const CredentialAccessTimeKeys = Object.create(Enum, {
  START_SEC: { value: 'STARTSEC', enumerable: true },
  END_SEC: { value: 'ENDSEC', enumerable: true },
  START_ISO: { value: 'DTSTART', enumerable: true },
  END_ISO: { value: 'DTEND', enumerable: true },
  toTemplateISOString: {
    value: function() {
      return this.START_ISO + '=' + '%s;' + this.END_ISO + '=' + '%s';
    },
    enumerable: false,
  },
  toTemplateString: {
    value: function() {
      return this.START_SEC + '=' + '%d;' + this.END_SEC + '=' + '%d';
    },
    enumerable: false,
  },
});

/**
 * Defines credential schedule actions.
 *
 * @enum
 * @readonly
 */
const CredentialScheduleActions = Object.create(Enum, {
  LOAD: { value: 'loadedcredentialschedule', enumerable: true },
  ENABLE: { value: 'enabledcredentialschedule', enumerable: true },
  DELETE: { value: 'removedcredentialschedule', enumerable: true },
  DISABLE: { value: 'disabledcredentialschedule', enumerable: true },
  UPDATE: { value: 'updatedcredentialschedule', enumerable: true },
});

/**
 * Defines credential payload statuses.
 *
 * @enum
 * @readonly
 */
const CredentialPayloadStatuses = Object.create(Enum, {
  CONFLICT: { value: 'conflict', enumerable: true },
  FAILURE: { value: 'failure', enumerable: true },
  SUCCESS: { value: 'success', enumerable: true },
});

/**
 * Defines credential types.
 *
 * @enum
 * @readonly
 */
const LockCredentialTypes = Object.create(Enum, {
  PIN: { value: 'pin', enumerable: true },
  RF: { value: 'rf', enumerable: true },
  FINGER: { value: 'finger', enumerable: true },
  FACE: { value: 'face', enumerable: true },
  RFID_HID: { value: 'rfid_hid', enumerable: true },
  ASSOCIATED_PIN: { value: 'associated_pin', enumerable: true },

  pinLikeTypes: {
    value: function() {
      return [this.PIN, this.ASSOCIATED_PIN];
    },
    enumerable: false,
  },

  /**
   * Check if the credential is a regular pin
   */
  isPin: {
    value: function(type) {
      return this.pinLikeTypes().includes(type);
    },
    enumerable: false,
  },
});

/**
 * Defines credential schedule types.
 *
 * @enum
 * @readonly
 */
const LockCredentialScheduleTypes = Object.create(Enum, {
  RF: { value: 'rfid', enumerable: true },
  FINGER: { value: 'finger', enumerable: true },
  FACE: { value: 'face', enumerable: true },
  ASSOCIATED_PIN: { value: 'associated_pin', enumerable: true },
  ALL: { value: 'all', enumerable: true },
});

/**
 * @const {number}
 * Credential maximum length.
 */
const CREDENTIAL_LEN_MAX = 16;

exports.CredentialScheduleSynCommandStates = CredentialScheduleSynCommandStates;
exports.CredentialScheduleSynCommandActions = CredentialScheduleSynCommandActions;
exports.CredentialScheduleStates = CredentialScheduleStates;
exports.CredentialAccessTypes = CredentialAccessTypes;
exports.CredentialAccessTimeKeys = CredentialAccessTimeKeys;
exports.CredentialScheduleActions = CredentialScheduleActions;
exports.CredentialPayloadStatuses = CredentialPayloadStatuses;
exports.LockCredentialTypes = LockCredentialTypes;
exports.LockCredentialScheduleTypes = LockCredentialScheduleTypes;
exports.CREDENTIAL_LEN_MAX = CREDENTIAL_LEN_MAX;
